interface SectionTitleProps {
  title: string;
  subtitle?: string;
  action?: { label: string; to: string };
}

export default function SectionTitle({ title, subtitle, action }: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between mb-5 md:mb-7">
      <div>
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 flex items-center gap-2.5">
          <span className="w-2 h-6 rounded-full bg-accent-500"></span>
          {title}
        </h2>
        {subtitle && (
          <p className="mt-1.5 text-sm text-foreground-600">{subtitle}</p>
        )}
      </div>
      {action && (
        <button
          onClick={() => window.REACT_APP_NAVIGATE(action.to)}
          className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
        >
          {action.label}
          <i className="ri-arrow-right-line"></i>
        </button>
      )}
    </div>
  );
}